/**
 * Sanitizes user input by removing potentially dangerous characters
 * Removes: < > ; ' "
 */
export function sanitizeUserInput(text: string): string {
  if (!text) return '';
  return text.replace(/[<>;'"]/g, '').slice(0, 500); // Also limit to 500 chars
}
